import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as _ from 'underscore';
import { UserData } from '../shared/service/UserService';

@Injectable()
export class AdminService {
    private apiUrl: string;
    private header;
    private headerAppJSON;
    constructor(private http: HttpClient) {
        this.apiUrl = UserData.backend_url + '/v1';
        this.header = this.getHeader();
        this.headerAppJSON = this.getHeaderAppJSON();
    }

    public getHeader() {
        let authorizationString = "Bearer " + UserData.token;
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': authorizationString
            })
        };
        return httpOptions;
    }

    public getHeaderAppJSON() {
        let authorizationString = "Bearer " + UserData.token;
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': authorizationString,
                'Content-Type': 'application/json'
            })
        };
        return httpOptions;
    }

    public getAdminDetails() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/getAdminAppAndPermDetails/';
        return this.http.get(url, this.header);
    }
    public getUserDetails(token) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/userDetails/';
        return this.http.get(url, this.headerAppJSON);
    }

    public permission(userName: string) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/appRolesAndPermFromUserName?userName=' + userName;
        return this.http.get(url, this.headerAppJSON);
    }

    public updateData(data) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/updateUserPermission';
        return this.http.post(url, data, this.headerAppJSON);
    }


    public deleteUser(userName: string) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/users?userName=' + userName;
        return this.http.delete(url, this.headerAppJSON);
    }

    public transferUserRights(userName: string, transferUser: string) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/deleteUser/' + userName + '/transferUser/' + transferUser;
        return this.http.post(url, this.headerAppJSON);
    }

    public applyAppsSharing(data) {
        const url = this.apiUrl + '/applyAppsSharing?userName=' + data.userName;
        return this.http.post(url, this.headerAppJSON);
    }

    public removeAppsSharing(data) {
        const url = this.apiUrl + '/removeAppsSharing?userName=' + data.userName;
        return this.http.post(url, this.headerAppJSON);
    }

    public getTeams() {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/teams/';
        return this.http.get(url, this.header);
    }
    public getMembers(teamId) {
        const url = this.apiUrl + '/membersByTeam/' + teamId;
        return this.http.get(url, this.header);
    }

    public updateJoinableTeams(isJoinableTeam,teamId){
        const url = this.apiUrl + '/updateTeams/' + teamId + "/" + isJoinableTeam;
        return this.http.post(url, this.headerAppJSON);
    }

    public removeMemberFromTeam(teamId){
        const url = this.apiUrl + '/removeMemberTeam/' + teamId;
        return this.http.post(url, this.headerAppJSON);
    }

    public joinMemberToTeam(teamId){
        const url = this.apiUrl + '/joinMemberTeam/' + teamId;
        return this.http.post(url, this.headerAppJSON);
    }

    public getInviteMember() {
        const url = this.apiUrl + '/userList/';
        return this.http.get(url, this.header);
    }

    public invitePendingMember() {
        const url = this.apiUrl + '/pendingUsersInvitation/';
        return this.http.get(url, this.header);
    }
    public getUserByEmailInvitation(email) {
        const url = this.apiUrl + '/getUserByEmailInvitation?email=' + email;
        return this.http.get(url, this.header);
    }

    public postTeam(data) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/team/';
        return this.http.post(url, data, this.header);
    }

    public cancelUserInvitation(data) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/cancelUserInvitation/';
        return this.http.post(url, data, this.header);
    }

    public postInviteMember(data) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/addUserInOrg/';
        return this.http.post(url, data, this.header);
    }

    public inviteSingleMember(data) {
        const url = this.apiUrl + '/isUserExistInvitation?email=' + data.email;
        return this.http.get(url, this.header);
    }

    public inviteMemberStatus(data) {
        const url = this.apiUrl + '/createUserInvitation/';
        return this.http.post(url, data, this.header);
    }

    public postMember(data) {
        const url = this.apiUrl + '/members/';
        return this.http.post(url, data, this.header);
    }

    public saveUserPermissions(data) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/savePermissionInvitation/';
        return this.http.post(url, data, this.header);
    }

    public saveInviteTeam(data) {
        const url = this.apiUrl + '/addMemberInTeamInvitation/';
        return this.http.post(url, data, this.header);
    }

    public deleteTeam(teamId: string) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/teams/' + teamId;
        return this.http.delete(url, this.headerAppJSON);
    }

    public deleteMember(teamId: string, memberId: string) {
        const url = this.apiUrl + '/teams/' + teamId + '/members/' + memberId;
        return this.http.delete(url, this.headerAppJSON);
    }

    public updateTeam(teamId, teamDetail) {
        const url = this.apiUrl + '/teams/' + teamId + "/" + teamDetail;
        return this.http.post(url, teamDetail, this.header);
    }

    public userGamePermissions(data) {
        let organizationId: any = "noOrg";
        if (!_.isUndefined(UserData.organizationId))
            organizationId = UserData.organizationId;
        organizationId = organizationId == null ? "noOrg" : organizationId;
        const url = this.apiUrl + '/organizations/' + organizationId + '/userGamePermissionsMapping/';
        return this.http.post(url, data, this.header);
    }
    
    public teamRoleEdit(data) {
        const url = this.apiUrl + '/updateRoleInTeam';
        return this.http.post(url, data, this.header);
    }
}